(() => {
  'use strict';
  const card = document.querySelector('[data-ag-collection-bike]');
  const copyNode = document.querySelector('[data-ag-collection-copy]');
  const catalogNode = document.getElementById('ry-bike-catalog');
  if (!card || !copyNode || !catalogNode || card.dataset.ready) return;
  card.dataset.ready = 'true';
  let copy, catalog;
  try {
    copy = JSON.parse(copyNode.textContent);
    catalog = JSON.parse(catalogNode.textContent);
  } catch { return; }
  const name = card.querySelector('[data-ag-bike-name]');
  const note = card.querySelector('[data-ag-bike-note]');
  const apply = card.querySelector('[data-ag-bike-apply]');
  const param = catalog.param;
  const storageKey = 'ryvox:selected-bike:v2';
  function update() {
    const url = new URL(location.href);
    const active = url.searchParams.getAll(param).filter(Boolean);
    let saved = '';
    try {
      const candidate = JSON.parse(localStorage.getItem(storageKey));
      const known = (catalog.models || []).map(model => model.label).concat(catalog.newModels || []);
      if (known.includes(candidate?.label)) saved = candidate.label;
    } catch {}
    name.textContent = active.length ? active.join(', ') : saved || copy.selectBike;
    note.textContent = active.length ? copy.filtered : saved ? copy.saved : copy.check;
    card.classList.toggle('has-bike', !!(active.length || saved));
    apply.hidden = !saved || active.includes(saved);
    if (saved && !apply.hidden) {
      url.searchParams.set(param, saved);
      url.searchParams.delete('page');
      url.searchParams.delete('section_id');
      apply.href = url.pathname + url.search;
    }
  }
  update();
  window.addEventListener('storage', event => { if (event.key === storageKey) update(); });
  window.addEventListener('popstate', update);
  document.addEventListener('ryvox_bike_selected', () => requestAnimationFrame(update));
  const results = document.querySelector('[data-collection-results]');
  if (results) new MutationObserver(update).observe(results, {attributes: true, attributeFilter: ['aria-busy']});
})();
